export default __webpack_public_path__ + "static/media/01.156de087.png";